import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginGuard } from './Login/login.guard';

const routes: Routes = [
 
  {
    path: '',
    redirectTo: 'SIGET',
    pathMatch: 'full'
  },
  {
    path: 'Login',
    loadChildren: () => import('./Login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'SIGET',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule),
    canLoad: [LoginGuard]
  }



  


 
 
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
